import { useState } from 'react';

import { Feedback } from '@playbooks/molecules/feedbacks';
import { Button } from '@playbooks/ui/components/button';
import { Icon } from '@playbooks/ui/components/icon';
import { Input } from '@playbooks/ui/components/input';
import { InputGroup, InputGroupAddon } from '@playbooks/ui/components/input-group';

import { useStore } from 'contexts';
import { useAction } from 'hooks';

const IndexSplashForm = () => {
	const [email, setEmail] = useState('');
	const [sent, setSent] = useState(false);
	const store = useStore();

	// Actions
	const [onSave, saveTask] = useAction(async () => {
		await store.saveRecord({ url: '/subscribe', data: { email } });
		setSent(true);
	});
	const onSubmit = e => {
		e.preventDefault();
		onSave();
	};
	if (sent) {
		return (
			<Feedback
				layout='page'
				icon='circle-check'
				title="You're on the list."
				text="We'll be in touch soon."
				variant='success'
			/>
		);
	}
	return (
		<form onSubmit={onSubmit} className='mx-auto w-full max-w-md'>
			<InputGroup
				size='lg'
				className='h-13 w-full rounded-panel border-border bg-surface-control focus-within:border-white focus-within:ring-0'>
				<InputGroupAddon className='text-foreground-body pl-4'>
					<Icon type='far' icon='envelope' aria-hidden />
				</InputGroupAddon>
				<Input
					type='email'
					value={email}
					variant='group'
					placeholder='you@company.com'
					onChange={e => setEmail(e.target.value)}
					required
					className='h-full text-base text-white'
				/>
				<InputGroupAddon align='inline-end' className='p-2'>
					<Button type='submit' isLoading={saveTask.running}>
						Join waitlist
						<Icon data-icon='inline-end' type='far' icon='chevron-right' aria-hidden />
					</Button>
				</InputGroupAddon>
			</InputGroup>
		</form>
	);
};
export { IndexSplashForm };
